import React, {Component,useReducer,useEffect} from 'react'
import { Link } from 'react-router-dom'

import {
		Segment,
		Container,
		Menu,
		Image,
		Grid,
		Header,
		List,
		Button,
		Icon,
	} from 'semantic-ui-react'
import { useLocation } from 'react-router-dom'
import Feedback from 'xAppLib/UIelems/Feedback'
import ThemeSwitcher from 'xAppLib/UIelems/ThemeSwitcher'
import PrepFooter from 'views/iprep/Footer'
import IcannFooter from 'views/icann/Footer'
import IlegFooter from 'views/ileg/Footer'

const menu = [
	{
	  name: "About Us",
	  link: "/about-us/",
	},
	// {
	//   name: "Our Team",
	//   link: "/our-team/",
	// },
	// {
	//   name: "Careers",
	//   link: "/careers/",
	// },
	// {
	//   name: "News",
	//   link: "/blog/",
	// },
	/*{
	  name: "Customer Testimonials",
	  link: "/customer-testimonials/",
	},*/
	{
	  name: "Contact Us",
	  link: "#",
	},
	// {
	//   name: "Customer Terms & Conditions",
	//   link: "#",
	// },
	// {
	//   name: "Platform Terms & Conditions",
	//   link: "#",
	// },
	// {
	//   name: "Privacy Policy",
	//   link: "#",
	// },
  ];
  const second_menu = [
	// {
	//   name: "Request a Script",
	//   link: "/cat",
	// },
	// {
	//   name: "Telehealth Consultations",
	//   link: "/telehealth-consulting-services/",
	// },
	// {
	//   name: "Medical Certificates",
	//   link: "/online-medical-certificates/",
	// },
	// // {
	// //   name: "Pharmacy Locations",
	// //   link: "/locations/",
	// // },
	// {
	//   name: "For Doctors",
	//   link: "/doctor-consultation-jobs/",
	// },
	// {
	//   name: "For Pharmacies",
	//   link: "/pharmacy-registration/",
	// },
	// {
	//   name: "For Cosmetic Cinics",
	//   link: "https://instantcosmetics.com.au/",
	// },
	// {
	//   name: "FAQ",
	//   link: "/faq/",
	// },
  ]

export default function Footer() {
	const forceUpdate = useReducer(x => x + 1, 0)[1];
	const location = useLocation()

	const curr_page = location.pathname
	
	useEffect(() => {
		app.on(app.events.SITE_READY, forceUpdate)
		return () => {
			app.off(app.events.SITE_READY, forceUpdate);
		};
	}, []);

	
		if (app.settings.is_bare)
			return null
		
		if (app.settings.iprep)
			return <PrepFooter curr_page={curr_page}/>

		if (app.settings.icann)
			return <IcannFooter />

	    if (app.settings.ileg)
			return <IlegFooter />

	
		const links = app.app_data.ws_conf?.footer.items.map(it=>it.popup&&app.app_data.ws_conf.popups[it.popup]||it).map(it=>(!it.target || it.target.includes(app.runtime.app))&&it).filter(Boolean)
		return <div className='ui inverted vertical segment' id="site-footer">
		{(app.settings.is_term || app.settings.is_ionic) &&
			<Container >
				<Grid divided={false} inverted stackable>
					<Grid.Row>
						<Grid.Column width={12} >
							<List horizontal link inverted >
								{
									links && links.map( (it, i) => <List.Item
												content={app.settings.is_mob_sz && it.txt_shrt || it.txt}
												name={app.settings.is_mob_sz && it.txt_shrt || it.txt}
												as={it.tp == 'ln' ? Link : 'div'}
												to={it.u} 
												active={curr_page === it.u} 
												onClick={()=>it.tp=='pu' && app.trigger(app.events.SHOW_POPUP, it)}
												style={{cursor:'pointer'}}
												key={'foot_menu_more'+i}
											/>
										)
								}

								{/*<Feedback 
									trigger={<List.Item
												content={"Feedback"}
												style={{cursor:'pointer', color:'white'}}
												// name="Feedback"
												// icon="question circle"
											/>} />*/}

							</List>
						</Grid.Column>
						{/*<Grid.Column width={4}>
							<div className='flex md:justify-end'>
								<Image src="/images/mastercard.svg" style={{width: "40px"}}/>
								<Image src="/images/visa.svg" style={{margin: "0 8px", width: "40px"}}/>
								<Image src="/images/amex-logo.svg" style={{margin: "0 8px", width: "40px"}}/>
								{app.settings.show_paypal && <Image src="/images/paypal.svg" style={{width: "40px"}}/>}
							</div>
						</Grid.Column>*/}
						
						<Grid.Column width={8} verticalAlign='bottom'>
							<p className="text-center">	© {new Date().getFullYear()} {app.runtime.name}</p>
						</Grid.Column>
						<Grid.Column width={8} className='version'>
							{app.dvc.org&&<b>{app.dvc.org.name}<br/></b> || null}
							{app.runtime.org?.oid!='app'&&<i>{app.runtime.org?.name}<br/></i> || null}
							Build: {__GIT_HASH__} - {__BUILD__}
							{app.dev_env &&  ' - dev' || app.test_env &&  ' - test' || ''}
							&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
							<Icon
									compact="true"
									color="green"
									name="refresh"
									circular
									onClick={_=>window.location.reload(true)}
									style={{ cursor: 'pointer' }}
								  />
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Container>
		||
			<Container>
			  <div className="py-12 grid grid-cols-2 lg:grid-cols-4 text-left">
				
				<div className="col-span-1 flex flex-col justify-center items-center md:justify-start order-1 mb-4 lg:mb-0">
					<img src="/images/wewo logo.png" alt="WeWordle" className="logo mb-4 mx-auto"/>

					<div className='w-3/4 lg:w-56 mx-auto space-y-4 text-white font-400 mt-2'>

						<p className="mb-4">
							© {new Date().getFullYear()} WeWordle
						</p>
					</div>
				</div>

				<div className="col-span-1 order-3 lg:order-2">
					<ul className="space-y-4 w-3/4 lg:w-56 mx-auto text-white">
						{menu.map(({ name, link }, i) => {
							switch (name) {
							case 'Privacy Policy':
								return (
								<li key={name + i} onClick={() => app.trigger(app.events.SHOW_POPUP, {pt:"cx_txt",	txt:'Privacy', pn:'privacy-policy'})}>
								<Link to={link}>{name}</Link>
								</li>);
							case 'Customer Terms & Conditions':
								return (
								<li key={name + i} onClick={() => app.trigger(app.events.SHOW_POPUP, {pt:"cx_txt",	txt:'Customer Terms and Conditions', pn:'customer-terms-and-conditions'})}>
								<Link to={link}>{name}</Link>
								</li>);
							case 'Platform Terms & Conditions':
							return (
								<li key={name + i} onClick={() => app.trigger(app.events.SHOW_POPUP, {pt:"cx_txt",	txt:'Platform Terms and Conditions', pn:'platform-terms-and-conditions'})}>
								<Link to={link}>{name}</Link>
								</li>);
							case 'Contact Us':
								return (
								<li key={name + i} onClick={()=>app.trigger(app.events.SHOW_POPUP, {
									"tp": "pu",
									"pt": "contact",
									"txt": "Contact Us",
									"u": "contact-us",
									"pn": "contact-us",
									"target":"iscr"
								})}>
								<Link to={link}>{name}</Link>
								</li>);
							default:
								return <li key={name + i}>
										{link.startsWith('https://') ? <a href={link} target="_blank">{name}</a> : 
										<Link to={link}>{name}</Link>}
									</li>
						}})}
					</ul>
				</div>

				<div className="col-span-1 order-4 lg:order-3">
					<ul className="space-y-4 w-3/4 lg:w-56 mx-auto text-white">
						{second_menu.map(({ name, link }, i) => {
							return  <li key={name + i}>
										{link.startsWith('https://') ? <a href={link} target="_blank">{name}</a> : 
										<Link to={link}>{name}</Link>}
									</li>
							})
						}
					</ul>
				</div>

				<div className="col-span-1 order-2 lg:order-4">

					<div className='w-3/4 lg:w-56 mx-auto space-y-4 text-white font-400'>
						<div className="mb-4">
							<label className="block text-sm mb-2 opacity-80">Theme</label>
							<ThemeSwitcher compact />
						</div>
						<p className="mb-4 text-sm opacity-70">
							{app.dvc.org&&<b>{app.dvc.org.name}<br/></b> || null}
							{app.runtime.org?.oid!='app'&&<i>{app.runtime.org?.name}<br/></i> || null}
							Build: {__GIT_HASH__} - {__BUILD__}
							{app.dev_env &&  ' - dev' || app.test_env &&  ' - test' || ''}
							&nbsp;&nbsp;
							<Icon
									compact="true"
									color="green"
									name="refresh"
									circular
									onClick={_=>window.location.reload(true)}
									style={{ cursor: 'pointer' }}
								  />
						</p>
					</div>

				</div>
				
			  </div>
			</Container>
		}

		</div>
	

}
